import { useNavigate } from 'react-router';
import { useBrand } from '@/hooks/pwa/use-brand';
import { useDisplayMode } from '@/hooks/use-user-platform';
import { brandThemeSchema } from '@/models/configuration';
import ROUTES from '@/routes';
import { useUserId } from '@/stores/auth';
import { useConfigurationStore } from '@/stores/configuration';

export function ThemeSwitcher() {
  const navigate = useNavigate();
  const brand = useBrand();
  const [displayMode, setDisplayMode] = useDisplayMode();
  const activeUserId = useUserId();

  const handleToggleTheme = () => {
    if (!brand.theme) return;

    const currentThemeIndex = brandThemeSchema.options.indexOf(brand.theme);
    const nextTheme = brandThemeSchema.options.at((currentThemeIndex + 1) % brandThemeSchema.options.length);

    if (!nextTheme) return;

    useConfigurationStore.getState().setTheme(nextTheme);
  };

  const handleSwitchActiveUser = () => {
    navigate(ROUTES.AUTH.SWITCH.$path());
  };

  return (
    <div className='fixed top-0 inset-x-1.5 gap-1.5 flex justify-end items-start z-50'>
      <button
        type='button'
        className='btn btn-ghost btn-xs bg-primary rounded-t-none text-primary-content'
        onClick={handleToggleTheme}>
        {brand.theme}
      </button>

      {!!activeUserId && (
        <button
          type='button'
          className='btn btn-ghost btn-xs bg-cyan-500 rounded-t-none text-neutral-950'
          onClick={handleSwitchActiveUser}>
          {activeUserId}
        </button>
      )}

      <button
        type='button'
        className='btn btn-ghost btn-xs bg-amber-300 desktop:bg-amber-700 rounded-t-none text-neutral-950'
        onClick={() => setDisplayMode(displayMode === 'desktop' ? 'mobile' : 'desktop')}>
        {displayMode}
      </button>
    </div>
  );
}
